export const VINWONDER_TAGGROUP_LIST_ACTION='VINWONDER_TAGGROUP_LIST_ACTION'
export const VINWONDER_TAGGROUP_LIST_SUCCESS='VINWONDER_TAGGROUP_LIST_SUCCESS'
export const VINWONDER_TAGGROUP_LIST_FAIL='VINWONDER_TAGGROUP_LIST_FAIL'

export const VINWONDER_TAGGROUP_DETAIL_ACTION='VINWONDER_TAGGROUP_DETAIL_ACTION'
export const VINWONDER_TAGGROUP_DETAIL_SUCCESS='VINWONDER_TAGGROUP_DETAIL_SUCCESS'
export const VINWONDER_TAGGROUP_DETAIL_FAIL='VINWONDER_TAGGROUP_DETAIL_FAIL'

export const VINWONDER_TAGGROUP_LIST_SUPPLIERS_ACTION='VINWONDER_TAGGROUP_LIST_SUPPLIERS_ACTION'
export const VINWONDER_TAGGROUP_LIST_SUPPLIERS_SUCCESS='VINWONDER_TAGGROUP_LIST_SUPPLIERS_SUCCESS'
export const VINWONDER_TAGGROUP_LIST_SUPPLIERS_FAIL='VINWONDER_TAGGROUP_LIST_SUPPLIERS_FAIL'

export const VINWONDER_TAGGROUP_LIST_SKU_ACTION='VINWONDER_TAGGROUP_LIST_SKU_ACTION'
export const VINWONDER_TAGGROUP_LIST_SKU_SUCCESS='VINWONDER_TAGGROUP_LIST_SKU_SUCCESS'
export const VINWONDER_TAGGROUP_LIST_SKU_FAIL='VINWONDER_TAGGROUP_LIST_SKU_FAIL'

export const VINWONDER_TAGGROUP_DRAG_ACTION='VINWONDER_TAGGROUP_DRAG_ACTION'
export const VINWONDER_TAGGROUP_DRAG_SUCCESS='VINWONDER_TAGGROUP_DRAG_SUCCESS'
export const VINWONDER_TAGGROUP_DRAG_FAIL='VINWONDER_TAGGROUP_DRAG_FAIL'

export const VINWONDER_TAGGROUP_CREATE_ACTION='VINWONDER_TAGGROUP_CREATE_ACTION'
export const VINWONDER_TAGGROUP_CREATE_SUCCESS='VINWONDER_TAGGROUP_CREATE_SUCCESS'
export const VINWONDER_TAGGROUP_CREATE_FAIL='VINWONDER_TAGGROUP_CREATE_FAIL'

export const VINWONDER_TAGGROUP_UPDATE_ACTION='VINWONDER_TAGGROUP_UPDATE_ACTION'
export const VINWONDER_TAGGROUP_UPDATE_SUCCESS='VINWONDER_TAGGROUP_UPDATE_SUCCESS'
export const VINWONDER_TAGGROUP_UPDATE_FAIL='VINWONDER_TAGGROUP_UPDATE_FAIL'

export const VINWONDER_TAGGROUP_DELETE_ACTION='VINWONDER_TAGGROUP_DELETE_ACTION'
export const VINWONDER_TAGGROUP_DELETE_SUCCESS='VINWONDER_TAGGROUP_DELETE_SUCCESS'
export const VINWONDER_TAGGROUP_DELETE_FAIL='VINWONDER_TAGGROUP_DELETE_FAIL'

export const VINWONDER_TAGGROUP_CREATE_TRANSLATE_ACTION='VINWONDER_TAGGROUP_CREATE_TRANSLATE_ACTION'
export const VINWONDER_TAGGROUP_CREATE_TRANSLATE_SUCCESS='VINWONDER_TAGGROUP_CREATE_TRANSLATE_SUCCESS'
export const VINWONDER_TAGGROUP_UPDATE_TRANSLATE_ACTION='VINWONDER_TAGGROUP_UPDATE_TRANSLATE_ACTION'
export const VINWONDER_TAGGROUP_UPDATE_TRANSLATE_SUCCESS='VINWONDER_TAGGROUP_UPDATE_TRANSLATE_SUCCESS'
export const VINWONDER_TAGGROUP_DELETE_TRANSLATE_ACTION='VINWONDER_TAGGROUP_DELETE_TRANSLATE_ACTION'
export const VINWONDER_TAGGROUP_DELETE_TRANSLATE_SUCCESS='VINWONDER_TAGGROUP_DELETE_TRANSLATE_SUCCESS'

export const VINWONDER_TAGGROUP_DRAG_TO_ORDER_ACTION='VINWONDER_TAGGROUP_DRAG_TO_ORDER_ACTION'
export const VINWONDER_TAGGROUP_DRAG_TO_ORDER_SUCCESS='VINWONDER_TAGGROUP_DRAG_TO_ORDER_SUCCESS'
export const VINWONDER_TAGGROUP_DRAG_TO_ORDER_FAIL='VINWONDER_TAGGROUP_DRAG_TO_ORDER_FAIL'

export const VINWONDER_TAGGROUP_UPDATE_DEFAULT_TAG_IN_SUPPLIER_ACTION='VINWONDER_TAGGROUP_UPDATE_DEFAULT_TAG_IN_SUPPLIER_ACTION'
export const VINWONDER_TAGGROUP_UPDATE_DEFAULT_TAG_IN_SUPPLIER_SUCCESS='VINWONDER_TAGGROUP_UPDATE_DEFAULT_TAG_IN_SUPPLIER_SUCCESS'
export const VINWONDER_TAGGROUP_UPDATE_DEFAULT_TAG_IN_SUPPLIER_FAIL='VINWONDER_TAGGROUP_UPDATE_DEFAULT_TAG_IN_SUPPLIER_FAIL'
